import { v4 as uuidv4 } from 'uuid'
import { DateTime } from 'luxon'
import { log } from '@/services/log'
import { ref } from 'vue'

const handlerKeys = ['interactiveTime', 'waitTime', 'contentTime', 'navbarTime', 'filterTime']
const NAME = 'User Activity Observer'
export function useActivityObserver() {
  const activity = ref()
  const timers = {}

  const resetStartTime = (types = handlerKeys) => {
    types.forEach((type) => (timers[type] = 0))
  }

  resetStartTime()

  const createActivity = (moduleName, activityName, user) => {
    const now = DateTime.now().toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss")
    // const start = this.#waitStartMillis ?? 0
    // const waitTime = start > 0 ? Date.now() - start : 0
    resetStartTime()

    activity.value = {
      externalId: uuidv4(),
      status: 'ACTIVE',
      moduleName,
      activityName,
      startTimestamp: now,
      endTimestamp: null,
      numRefreshes: 0,
      dirty: 'false',
      pending: 'true',
      user,
      ...timers,
    }
  }

  const closeUserActivity = async (dexie) => {
    const act = activity.value
    if (act == null) {
      log(NAME, 'No current activity available', act)
      return
    }
    log(NAME, 'Going to close current activity', activity, dexie)
    act.endTimestamp = DateTime.now().toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss")
    const now = Date.now()
    handlerKeys.forEach((key) => (act[key] += now - (timers[key] || now)))
    act.dirty = 'true'
    act.pending = 'false'
    await dexie.table('userActivity').put({ ...act })
  }

  const startInteractionRecording = (type) => {
    timers[type] = Date.now()
    log(NAME, 'Inside start interaction recording class type', type, timers)
  }

  const endInteractionRecording = (type) => {
    const now = Date.now()
    const activityMillis = now - (timers[type] || now)
    resetStartTime([type])
    const act = activity.value
    if (act != null) {
      act[type] += activityMillis
      if (type === 'waitTime') act.numRefreshes += 1
      log(
        NAME,
        'Inside end interaction recording - Activity recording for type',
        type,
        'activityMillis',
        activityMillis
      )
      activity.value = act
    }
  }

  return {
    endInteractionRecording,
    startInteractionRecording,
    closeUserActivity,
    createActivity,
    activity,
  }
}
